export enum GreenIdStatusEnum {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  FAILED = 2,
  VERIFIED = 3,
  VERIFIED_UNDERAGE = 4,
  PENDING_REVIEW = 5,
  FAILED_DUPLICATE = 6,
}
